import * as Yup from 'yup'

import { UpdateBespokeRatingValues } from './models'

export const updateBespokeRatingValidationSchema: Yup.SchemaOf<UpdateBespokeRatingValues> = Yup.object().shape({
  startDate: Yup.date(),
  maxLimitShort: Yup.number().required(),
  maxLimitLong: Yup.number().required(),
  maxMoneyLimitShort: Yup.number().required(),
  maxMoneyLimitLong: Yup.number().required(),
})
